import { Container, Section, Flex, withBorder, withPadding, Text, Box} from 'sg-styleguide';
import SelectBox from '../select-box';

const FlexWithPadding = withPadding(Flex);
const SectionWithPadding = withPadding(Section);
const ContainerWithPadding = withPadding(Container);
const SelectBoxWithBorder = withBorder(SelectBox);
const BoxWithPadding = withPadding(Box);
const TextWithPadding = withPadding(Text);
const SelectBoxwithBorder = withBorder(SelectBox);

const localize = ( object ) => {
	if ( window.wizardData.locale in object ) {
		return object[window.wizardData.locale]
	}

	return object['default'];
}

export {
	FlexWithPadding,
	SectionWithPadding,
	ContainerWithPadding,
	SelectBoxWithBorder,
	BoxWithPadding,
	TextWithPadding,
	SelectBoxwithBorder,
	localize
}